import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IMajSpider, setFilteredMajSpider } from "../../store/siteWebSlice";




const SearchBar = () => {


  const dispatch = useDispatch();
  const { majSpiders } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState("");


  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setFilteredMajSpider([...majSpiders]));
    } else {
      const result: any = majSpiders.filter(
        (item: IMajSpider, index: number) => {
          const value: any = `${item.versionNumber} ${item.versionDate}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredMajSpider(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
